import { PocButton } from 'commons/components/components-wrapper/poc-button.component';
import { useTranslation } from 'core/i18n/i18n';
import { useParams } from 'react-router-dom';
import { EapSettingsFormGeneral } from './components/eap-settings-form-general/eap-settings-form-general.component';
import { mapEapSettingsToFormGeneral } from './components/eap-settings-form-general/eap-settings-form-general.mapper';
import { EapSettingsFormHeader } from './components/eap-settings-form-header/eap-settings-form-header.component';
import { EapSettingsFormProtocol } from './components/eap-settings-form-protocol/eap-settings-form-protocol.component';
import { mapEapSettingsToFormProtocol } from './components/eap-settings-form-protocol/eap-settings-form-protocol.mapper';
import { useEapSettingsForm } from './hooks/use-eap-settings-form/use-eap-settings-form.hook';
import { EapSettingsFormValidationProvider } from './providers/eap-settings-validation-form.provider';
import { EapFormContentWrapper, EapWorkflowOverlayComponent } from './settings-devices-eap-settings-form.style';

export const SettingsDevicesEapSettingsFromContainer: React.FC = () => {
    const { t } = useTranslation();
    const { eapSettingId } = useParams<{ eapSettingId: string }>();

    const {
        eapSettings,
        isEditMode,
        isLoading,
        isFetchLoading,
        errors,
        assignedDeviceCount,
        handleDataChange,
        handleSave,
        unsavedData,
        isDataValid,
    } = useEapSettingsForm(eapSettingId);

    return (
        <EapWorkflowOverlayComponent
            visible
            loading={isFetchLoading}
            headerTitle={
                isEditMode
                    ? t('settings.devices.eap-settings.eap-config-create-form.header.edit')
                    : t('settings.devices.eap-settings.eap-config-create-form.header.add')
            }
            onClose={() => unsavedData.showUnsavedChangesIfNeededOrClose()}
            className="show-header"
            footer={[
                <PocButton key={'save-button'} onClick={handleSave} disabled={isLoading || !isDataValid()}>
                    {t('settings.devices.eap-settings.eap-config-create-form.button.save')}
                </PocButton>,
            ]}
        >
            <EapSettingsFormHeader
                title={eapSettings?.name || t('settings.devices.eap-settings.eap-config-create-form.header.title')}
                subtitle={t('settings.devices.eap-settings.eap-config-create-form.header.device-assigned', {
                    count: assignedDeviceCount,
                })}
            />
            <EapFormContentWrapper>
                <EapSettingsFormValidationProvider errors={errors}>
                    <EapSettingsFormGeneral
                        mode={isEditMode ? 'edit' : 'create'}
                        data={mapEapSettingsToFormGeneral(eapSettings)}
                        onDataChange={handleDataChange}
                    />
                    <EapSettingsFormProtocol
                        data={mapEapSettingsToFormProtocol(eapSettings)}
                        onDataChange={handleDataChange}
                    />
                </EapSettingsFormValidationProvider>
            </EapFormContentWrapper>
        </EapWorkflowOverlayComponent>
    );
};
